import Vue from "vue";
import i18n from "@/i18n";
import store from "../store";

Vue.filter("i18n", label => i18n.t(label));
Vue.filter("showDate", date =>
  moment(date).isValid()
    ? moment(date).format("DD-MM-YYYY")
    : i18n.t("date.invalid")
);
Vue.filter("showHour", date =>
  moment(date).isValid()
    ? moment(date).format("DD-MM-YYYY HH:mm")
    : i18n.t("date.invalid")
);
Vue.filter("showHourOnly", date =>
  moment(date).isValid() ? moment(date).format("HH:mm") : i18n.t("date.invalid")
);
Vue.filter("checkDate", date =>
  moment(date).isValid() ? moment(date).format("DD-MM-YYYY") : undefined
);
Vue.filter("checkParam", value => {
  //   console.log(value + " " + typeof value);
  // console.log( value + " " + typeof value )
  if (value == null || (typeof value == "string" && value.trim() == ""))
    return "-";
  else {
    var type = typeof value;
    if (value == "true" || value == "false") type = "boolean";

    //console.log( value + " " + type )
    // console.log( value + " " + type )

    switch (type) {
      case "boolean":
        return i18n.t(value == "true" || value === true ? "si" : "no");
      default:
        return value;
    }
  }
});
Vue.filter(
  "eventEditionName",
  event => event.name + "'" + event.edition.substring(2)
);
Vue.filter(
  "toMoney", function(current){
    let event = store.getters[ 'events/getCurrentEvent' ]()
    let coin =  event.type_id == 15 ? '$' : '€'
    return (Math.round(current * 100) / 100)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, "_")
      .replace(/\./, ",")
      .replace("_", ".") + coin
});
